/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Grid,
	Button,
	Dialog,
	DialogTitle,
	IconButton,
	DialogContent,
	useMediaQuery,
	useTheme,
	tableCellClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowUpward from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownward from '@mui/icons-material/ArrowDownwardOutlined';
import { useNavigate } from 'react-router';
import { orderBy } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import { APIKeys } from '../utils/Filter';
import { Numbers, PageRows } from '../utils/Enum';
import {
	IDateFilter,
	IEndUserQuestionnarieListingDataItem,
	ITransferUniversalDashBoardData,
} from '../types/CommonTypes';
import { ReactComponent as DownArrow } from '../assets/images/Doarrow-narrow-up.svg';
import {
	getFilterDate,
	pageIndex,
	setFilterDate,
	setPageIndex,
	setRowsPerPageValue,
	configurationData,
} from '../redux/SurveySlice';
import { useAppDispatch, useAppSelector } from '../app/Hooks';
import {
	EndUserSurveyModifiedListingData,
	fetchQuestionnaireSurveyData,
	setModifiedEndUserSurveyResponse,
} from '../redux/QuestionnarieUserSlice';
import { STEPTheme } from '../utils/Theme';
import { commonLabels } from '../utils/CommonLabels';
import { messages } from '../utils/Messages';
import { ReactComponent as EditLogo } from '../assets/images/Edit-Icon.svg';
import { ReactComponent as RightArrowBlack } from '../assets/images/arrow-narrow-right.svg';
import { ReactComponent as ActiveFilterLogo } from '../assets/images/Enablefilter-funnel.svg';
import { ReactComponent as FilterLogo } from '../assets/images/filter-funnel-02.svg';
import { BASIC_CONSTANT, END_USER_CONSTANT } from '../constants/StepConstants';
import { AppDispatch } from '../app/Store';
import { getUserAgentBrowser, getUserAgentOS } from '../utils/CommonMethods';
import {
	TransferUniversalDashboardData,
	selectUniversalDashboardResponse,
} from '../redux/TransferUniversalDashboardDataSlice';
import FilterCalender from './FilterCalender';
import FallbackUI from './common/FallbackUi';
import StyledTooltip from './StyledTooltip';
import { slotProps } from './questions/common/QuestionStyles';

const StyledTableHeaderCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: STEPTheme.colors.background,
		color: 'black',
	},
}));

const dueDateSegment = (
	isDueDateOpen: boolean,
	setDueDateOpen: Dispatch<SetStateAction<boolean>>
) => {
	return isDueDateOpen ? (
		<StyledTooltip title={commonLabels.dueDateTooltip} placement="top">
			<FilterLogo
				className="cursor-pointer"
				onClick={() => setDueDateOpen(true)}
			/>
		</StyledTooltip>
	) : (
		<ActiveFilterLogo
			className="cursor-pointer"
			onClick={() => setDueDateOpen(true)}
		/>
	);
};

const QuestionarieSurveyTable = () => {
	const theme = useTheme();
	const isLargeScreen = useMediaQuery(
		theme.breakpoints.up(Numbers.thousandTwentyFive)
	);
	const date = useAppSelector(getFilterDate);
	const universalTransferDashboardDataResponse = useAppSelector(
		selectUniversalDashboardResponse
	);
	const surveyTablePageIndex: number = useAppSelector(pageIndex);
	const questionnairesList: IEndUserQuestionnarieListingDataItem[] =
		useAppSelector(EndUserSurveyModifiedListingData);
	const totalQuestionnaires = questionnairesList.length;
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const configs = useAppSelector(configurationData);
	const [surveyNameSortObj, setSurveyNameSortObj] = React.useState(' ');
	const [surveyIdSortObj, setSurveyIdObj] = React.useState(' ');
	const [dueDateObj, setDueDateObj] = React.useState(' ');
	const [startDateObj, setStartDateObj] = React.useState(' ');
	const [dueDateOpen, setDueDateOpen] = React.useState(false);
	const [startDateOpen, setStartDateOpen] = React.useState(false);
	const [enduserListingTriggered, setEndUserListingTriggered] =
		React.useState(false);
	useEffect(() => {
		!enduserListingTriggered &&
			getEndUserListingData(dispatch, setEndUserListingTriggered);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enduserListingTriggered]);
	useEffect(() => {
		dispatch(
			setFilterDate({
				startDate: '',
				endDate: '',
				createdAtStartDate: '',
				createdAtEndDate: '',
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const rowsPerPageArr = [
		Numbers.ten,
		Numbers.fifteen,
		Numbers.twenty,
		Numbers.twentyFive,
		Numbers.fifty,
		Numbers.hundred,
	];
	const rowPage =
		configs?.rows_per_page?.length > 0
			? configs?.rows_per_page?.map((i) => Number(i))
			: rowsPerPageArr;
	const [page, setPage] = React.useState(surveyTablePageIndex);
	const [rowsPerPage, setRowsPerPage] = React.useState(
		checkRowPerPage(rowPage)
	);

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
		dispatch(setPageIndex(newPage));
	};

	const clearAllSorting = () => {
		setSurveyNameSortObj(' ');
		setSurveyIdObj(' ');
		setDueDateObj(' ');
		setStartDateObj(' ');
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
		dispatch(setRowsPerPageValue(rowsPerPage));
		dispatch(setPageIndex(Numbers.zero));
	};

	const handleClose = () => {
		setDueDateOpen(false);
		setStartDateOpen(false);
	};

	useEffect(() => {
		setDueDateOpen(false);
		setStartDateOpen(false);
		setPage(Numbers.zero);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionnairesList]);

	const handleSortClick = (value: string, key: string) => {
		clearAllSorting();
		const sortKeyValue = { value, key };
		value = handleSortBy(
			sortKeyValue,
			setSurveyNameSortObj,
			setSurveyIdObj,
			setStartDateObj,
			setDueDateObj
		);
		handleSortCodeId(value, key, questionnairesList, dispatch);
	};

	const handleRedirectionEndUser = (
		row: IEndUserQuestionnarieListingDataItem
	) => {
		navigate(`/end-user/${row?.questionnaireId}`);
	};

	const handleRedirection = (
		questionnaireType: string | undefined,
		questionnaireId: string
	) => {
		if (questionnaireType === BASIC_CONSTANT.SINGLE_PAGE) {
			navigate(`/cwuser/${questionnaireId}`);
		} else {
			navigate(`/end-user/${questionnaireId}`);
		}
	};

	const useStyles = makeStyles({
		tableRowBg: {
			background: STEPTheme.colors.white,
			borderRadius: 16,
		},
		paginationBorder: {
			borderRadius: '16px',
		},
		tableCellActionButton: {
			[theme.breakpoints.down(Numbers.thousandTwentyFive)]: {
				position: 'sticky',
				right: 0,
				borderLeft: `{2px solid ${STEPTheme.colors.white}`,
				background: STEPTheme.colors.background,
			},
		},
	});

	const HeadText = styled('div')({
		width: 'auto',
		height: '22px',
		fontFamily: 'JohnsonText-Regular',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '16px',
		letterSpacing: '0px',
		textAlign: 'left',
		display: 'flex',
		svg: {
			cursor: 'pointer',
		},
		'.up-arrow': {
			svg: {
				cursor: 'pointer',
				transform: 'rotate(180deg)',
			},
		},
	});
	const StyledButton = styled(Button)({
		height: '40px',
		color: STEPTheme.colors.black,
		background: 'transparent',
		borderRadius: '8px',
		justify: 'space-between',
		border: `none`,
		textTransform: 'none',
		textAlign: 'left',
		padding: '4px 10px',
		lineHeight: '16px',
		fontSize: '14px',
		'&:hover': {
			backgroundColor: STEPTheme.colors.linkGray,
		},
	});

	const classes = useStyles();

	useEffect(() => {
		const logInUserDetails = JSON.parse(
			`${localStorage.getItem('userDetails')}`
		);

		if (logInUserDetails?.idSession) {
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: commonLabels.END_USER,
					PageSubTitle: commonLabels.homePageTxt,
					PageURL: window.location.href,
					id: null,
					IdSession: logInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime: new Date().toISOString(),
					visitEndTime: null,
					userEmailId: configs?.user?.userEmailId || '',
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		}

		if (
			universalTransferDashboardDataResponse?.id &&
			universalTransferDashboardDataResponse?.visitStartTime
		) {
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: universalTransferDashboardDataResponse?.pageTitle,
					PageSubTitle: '',
					PageURL: universalTransferDashboardDataResponse?.pageURL,
					id: universalTransferDashboardDataResponse?.id,
					IdSession: logInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime:
						universalTransferDashboardDataResponse?.visitStartTime,
					visitEndTime: new Date().toISOString(),
					userEmailId: configs?.user?.userEmailId || '',
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		}
	}, []);

	useEffect(() => {
		const onBeforeUnload = () => {
			const logInUserDetails = JSON.parse(
				`${localStorage.getItem('userDetails')}`
			);
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: universalTransferDashboardDataResponse?.pageTitle,
					PageSubTitle: '',
					PageURL: universalTransferDashboardDataResponse?.pageURL,
					id: universalTransferDashboardDataResponse?.id,
					IdSession: logInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime:
						universalTransferDashboardDataResponse?.visitStartTime,
					visitEndTime: new Date().toISOString(),
					userEmailId: configs?.user?.userEmailId || '',
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		};

		window.addEventListener('beforeunload', onBeforeUnload);
		return () => {
			window.removeEventListener('beforeunload', onBeforeUnload);
		};
	}, []);

	const [inactivityTimeout, setInactivityTimeout] =
		React.useState<NodeJS.Timeout | null>(null);
	const [hasCalledAPI, setHasCalledAPI] = React.useState<boolean>(false);

	const callInactivityAPI = () => {
		if (hasCalledAPI) return;
		setHasCalledAPI(true);
		const logInUserDetails = JSON.parse(
			`${localStorage.getItem('userDetails')}`
		);

		const univeralDashboardPayload: ITransferUniversalDashBoardData = {
			apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
			apiType: 'POST',
			apiBody: {
				PageTitle: universalTransferDashboardDataResponse?.pageTitle,
				PageSubTitle: '',
				PageURL: universalTransferDashboardDataResponse?.pageURL,
				id: universalTransferDashboardDataResponse?.id,
				IdSession: logInUserDetails?.idSession ?? null,
				browser: getUserAgentBrowser(),
				os: getUserAgentOS(),
				visitStartTime: universalTransferDashboardDataResponse?.visitStartTime,
				visitEndTime: new Date().toISOString(),
				userEmailId: configs?.user?.userEmailId || '',
			},
		};

		dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
	};
	return totalQuestionnaires > 0 ? (
		<>
			<TableContainer
				sx={{
					borderRadius: '12px',
					maxHeight: '420px',
					maxWidth: '100%',
					boxShadow: ' 0px 5px 6px rgba(0, 0, 0, 0.16)',
					background: STEPTheme.colors.background,
				}}
			>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							<StyledTableHeaderCell>
								<HeadText>
									{commonLabels.QUESTIONNAIRE_NAME}
									<StyledTooltip
										title={commonLabels.columnHeaderTooltip}
										placement="top"
									>
										{questionnaireHeaderCell(
											surveyNameSortObj,
											'questionnaireName',
											handleSortClick
										)}
									</StyledTooltip>
								</HeadText>
							</StyledTableHeaderCell>

							<StyledTableHeaderCell>
								<HeadText>
									{commonLabels.QUESTIONNAIRE_ID}
									<StyledTooltip
										title={commonLabels.columnHeaderTooltip}
										placement="top"
									>
										{questionnaireHeaderCell(
											surveyIdSortObj,
											'questionnaireCode',
											handleSortClick
										)}
									</StyledTooltip>
								</HeadText>
							</StyledTableHeaderCell>

							<StyledTableHeaderCell>
								<HeadText>
									{commonLabels.START_DATE}

									<StyledTooltip
										title={commonLabels.columnHeaderTooltip}
										placement="top"
									>
										{questionnaireHeaderCell(
											startDateObj,
											'startDate',
											handleSortClick
										)}
									</StyledTooltip>
									{checkStartDateOpen(startDateOpen, date) ? (
										<StyledTooltip
											title={commonLabels.startDateTooltip}
											placement="top"
										>
											<FilterLogo
												className="cursor-pointer"
												onClick={() => setStartDateOpen(true)}
											/>
										</StyledTooltip>
									) : (
										<ActiveFilterLogo
											className="cursor-pointer"
											onClick={() => setStartDateOpen(true)}
										/>
									)}
								</HeadText>
							</StyledTableHeaderCell>
							<Dialog
								open={startDateOpen}
								onClose={() => setStartDateOpen(false)}
								style={{ marginTop: '150px' }}
							>
								<DialogTitle variant="h5">
									{commonLabels.selectStartDate}
								</DialogTitle>
								<IconButton
									aria-label="close"
									onClick={handleClose}
									sx={{
										position: 'absolute',
										right: Numbers.eight,
										top: Numbers.eight,
									}}
								>
									<CloseIcon />
								</IconButton>
								<DialogContent>
									<FilterCalender type={'startDate'} scope={'endUser'} />
								</DialogContent>
							</Dialog>

							<StyledTableHeaderCell>
								<HeadText>
									{commonLabels.END_DATE}
									<StyledTooltip
										title={commonLabels.columnHeaderTooltip}
										placement="top"
									>
										{questionnaireHeaderCell(
											dueDateObj,
											'dueDate',
											handleSortClick
										)}
									</StyledTooltip>
									{dueDateSegment(
										checkDueDateOpen(dueDateOpen, date),
										setDueDateOpen
									)}
								</HeadText>
							</StyledTableHeaderCell>
							<Dialog
								open={dueDateOpen}
								onClose={() => setDueDateOpen(false)}
								style={{ marginTop: '150px' }}
							>
								<DialogTitle variant="h5">
									{commonLabels.selectDueDate}
								</DialogTitle>
								<IconButton
									aria-label="close"
									onClick={handleClose}
									sx={{
										position: 'absolute',
										right: Numbers.eight,
										top: Numbers.eight,
									}}
								>
									<CloseIcon />
								</IconButton>
								<DialogContent>
									<FilterCalender type={'dueDate'} scope={'endUser'} />
								</DialogContent>
							</Dialog>

							<StyledTableHeaderCell>
								<HeadText>{commonLabels.STATUS}</HeadText>
							</StyledTableHeaderCell>

							<StyledTableHeaderCell>
								<HeadText>{commonLabels.RESPONSE}</HeadText>
							</StyledTableHeaderCell>

							<TableCell
								className={classes.tableCellActionButton}
								sx={{ background: STEPTheme.colors.background }}
							>
								<HeadText> {commonLabels.ACTION}</HeadText>
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody className={classes.tableRowBg}>
						{questionnairesList
							?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
							?.map((row) => (
								<TableRow
									hover
									key={row.questionnaireCode}
									tabIndex={-1}
									sx={{ fontFamily: 'JohnsonText-Medium' }}
								>
									<TableCell className="break-all" component="th" scope="row">
										{row.questionnaireName}
									</TableCell>
									<TableCell>{row.questionnaireCode}</TableCell>
									<TableCell>{row.startDate}</TableCell>
									<TableCell>
										{Number(row?.duration) > 0
											? `${row?.duration} ${commonLabels.days}`
											: row.dueDate}
									</TableCell>
									<TableCell>{row.questionnaireStatus}</TableCell>
									<TableCell>{row.answerStatus}</TableCell>
									<TableCell className={classes.tableCellActionButton}>
										<>
											{row.questionnaireStatus === commonLabels.Active &&
												(row.responseStatus === 'No' ? (
													<StyledButton
														onClick={() => handleRedirectionEndUser(row)}
													>
														{isLargeScreen &&
															commonLabels.Complete_Questionnaire}
														<RightArrowBlack />
													</StyledButton>
												) : (
													<StyledButton
														onClick={() =>
															handleRedirection(
																row.questionnaireType,
																row.questionnaireId
															)
														}
													>
														{isLargeScreen && commonLabels.Edit_Response}
														<EditLogo style={{ marginLeft: '5px' }} />
													</StyledButton>
												))}
											{row.questionnaireStatus === commonLabels.Completed && (
												<StyledButton> - </StyledButton>
											)}
										</>
									</TableCell>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</TableContainer>

			<Grid container sx={{ justifyContent: 'flex-end' }}>
				<StyledTooltip
					title={commonLabels.rowsPerPageListingScreenTooltip}
					placement="left"
				>
					<TablePagination
						className={classes.paginationBorder}
						rowsPerPageOptions={rowPage}
						component="div"
						sx={{
							'& .MuiTablePagination-toolbar': {
								paddingLeft: 0,
							},
							'& .MuiInputBase-root': {
								marginRight: {
									xs: '10px',
									sm: '10px',
									md: '32px',
									lg: '32px',
								},
							},
						}}
						slotProps={slotProps}
						count={totalQuestionnaires}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</StyledTooltip>
			</Grid>
		</>
	) : (
		<FallbackUI fallbackText={messages.common.NOT_QUESTIONNAIRE_FOUND} />
	);
};
export default QuestionarieSurveyTable;

const getEndUserListingData = (
	dispatch: AppDispatch,
	setEndUserListingTriggered: Dispatch<SetStateAction<boolean>>
) => {
	setEndUserListingTriggered(true);
	dispatch(fetchQuestionnaireSurveyData());
};

const handleSortBy = (
	sortKeyValue: { value: string; key: string },
	setSurveyNameSortObj: Dispatch<SetStateAction<string>>,
	setSurveyIdObj: Dispatch<SetStateAction<string>>,
	setStartDateObj: Dispatch<SetStateAction<string>>,
	setDueDateObj: Dispatch<SetStateAction<string>>
) => {
	if (sortKeyValue.value === APIKeys.questionnaireName) {
		setSurveyNameSortObj(sortKeyValue.key);
	} else if (sortKeyValue.value === APIKeys.questionnaireCode) {
		setSurveyIdObj(sortKeyValue.key);
	} else if (sortKeyValue.value === APIKeys.startDate) {
		setStartDateObj(sortKeyValue.key);
	} else if (sortKeyValue.value === APIKeys.dueDate) {
		setDueDateObj(sortKeyValue.key);
	} else {
		/* empty */
	}
	return sortKeyValue.value;
};

const handleSortCodeId = (
	value: string,
	key: string,
	questionnairesList: IEndUserQuestionnarieListingDataItem[],
	dispatch: AppDispatch
) => {
	if (key === ' ') {
		return;
	}
	if (value === APIKeys.questionnaireCode) {
		let sortAlphaNum = (
			a: IEndUserQuestionnarieListingDataItem,
			b: IEndUserQuestionnarieListingDataItem
		) =>
			a['questionnaireCode'].localeCompare(b['questionnaireCode'], 'en', {
				numeric: true,
			});
		if (key === END_USER_CONSTANT.DESCENDING) {
			sortAlphaNum = (
				a: IEndUserQuestionnarieListingDataItem,
				b: IEndUserQuestionnarieListingDataItem
			) =>
				b['questionnaireCode'].localeCompare(a['questionnaireCode'], 'en', {
					numeric: true,
				});
		}
		const copyList = [...questionnairesList];
		copyList.sort(sortAlphaNum);
		const sortedData = copyList;
		dispatch(setModifiedEndUserSurveyResponse(sortedData));
	} else {
		dispatch(
			setModifiedEndUserSurveyResponse(
				orderBy(questionnairesList, [value], key === 'asc' ? 'asc' : 'desc')
			)
		);
	}
};
const checkStartDateOpen = (startDateOpen: boolean, date: IDateFilter) => {
	return !startDateOpen && date.startDate === '' && date.endDate === '';
};

const checkDueDateOpen = (dueDateOpen: boolean, date: IDateFilter) => {
	return (
		!dueDateOpen &&
		date.createdAtStartDate === '' &&
		date.createdAtEndDate === ''
	);
};

const checkRowPerPage = (rowPage: number[]): number | (() => number) => {
	return rowPage ? rowPage[0] : PageRows.firstOption;
};

const questionnaireHeaderCell = (
	surveySortObj: string,
	headerName: string,
	handleSortClick: (value: string, key: string) => void
) => {
	if (surveySortObj === END_USER_CONSTANT.DESCENDING) {
		return (
			<ArrowDownward
				data-testid="sortByNameDesc"
				color="error"
				fontSize="inherit"
				className="text-base"
				onClick={() => {
					handleSortClick(headerName, ' ');
				}}
			/>
		);
	} else if (surveySortObj === END_USER_CONSTANT.ASCENDING) {
		return (
			<ArrowUpward
				data-testid="sortByName"
				color="error"
				fontSize="inherit"
				className="text-base"
				onClick={() => {
					handleSortClick(headerName, END_USER_CONSTANT.DESCENDING);
				}}
			/>
		);
	} else {
		return (
			<div className="up-arrow">
				<DownArrow
					onClick={() => {
						handleSortClick(headerName, END_USER_CONSTANT.ASCENDING);
					}}
				/>
			</div>
		);
	}
};
